import React from 'react';
import {useNavigate} from 'react-router-dom';

const ErrorPage = () => {
    const navigate = useNavigate();

    return (
        <div>
            <h1>404 - Seite nicht gefunden</h1>
            <button onClick={() => navigate('/')}>
                Zurück zum Dashboard
            </button>
        </div>
    );
};

export default ErrorPage;
